import React from "react";
import { PromoBanner } from "web/react/components/promo-section/promo-section";
import desktop from "./image-assets/DESKTOP.jpg";
import mobile from "./image-assets/MOBILE.jpg";
import tablet from "./image-assets/TABLET.jpg";
import desktopXl from "./image-assets/XL_DESKTOP.jpg";

interface AppDownloadPromoProps {
    adjustLink: string;
}

export default function AppDownloadPromo({ adjustLink }: AppDownloadPromoProps): JSX.Element {
    return (
        <PromoBanner
            url={adjustLink}
            mobile={mobile}
            tablet={tablet}
            desktop={desktop}
            desktop_xl={desktopXl}
            alt_text="Membership banner"
            is_adjust_link={true}
        />
    );
}
